import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, BadgeCheck, AlarmClock, XCircle, CreditCard, Newspaper, EyeOff } from "lucide-react";
import { api } from "@/lib/api";

const tiles = [
  { k: "total", label: "AP inscrits", icon: Users, cls: "text-slate-900", link: "/admin/ap" },
  { k: "valide", label: "Cartes valides", icon: BadgeCheck, cls: "text-emerald-700", link: "/admin/ap?statut=valide" },
  { k: "expire_bientot", label: "Expirent ≤ 60 jours", icon: AlarmClock, cls: "text-amber-600", link: "/admin/ap?statut=expire_bientot" },
  { k: "expiree", label: "Cartes expirées", icon: XCircle, cls: "text-rose-600", link: "/admin/ap?statut=expiree" },
  { k: "sans_carte", label: "Sans carte verte", icon: CreditCard, cls: "text-slate-500", link: "/admin/ap?statut=sans_carte" },
  { k: "masques", label: "Masqués (cotisation)", icon: EyeOff, cls: "text-rose-700", link: "/admin/ap?statut=masque" },
  { k: "articles", label: "Communiqués", icon: Newspaper, cls: "text-slate-900", link: "/admin/communiques" },
];

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Tableau de bord</h1>
        <p className="text-slate-500 mt-1">Vue d'ensemble du registre et des cartes vertes.</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {tiles.map((t, i) => (
          <Link key={t.k} to={t.link} data-testid={`stat-${t.k}`} className={`rise d${(i % 4) + 1} rounded-2xl bg-white border border-emerald-900/10 p-5 sm:p-6 hover:shadow-lg hover:-translate-y-0.5 transition-[box-shadow,transform]`}>
            <t.icon className={`h-5 w-5 ${t.cls}`} />
            <div data-testid={`stat-${t.k}-value`} className={`mt-4 font-display text-3xl sm:text-4xl font-extrabold ${t.cls}`}>{s ? s[t.k] : "—"}</div>
            <div className="text-sm text-slate-500 mt-1">{t.label}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
